"use client";
import React, { useEffect, useRef, useState } from "react";
import dynamic from "next/dynamic";
const IoMenu = dynamic(() =>
  import("react-icons/io5").then((mod) => mod.IoMenu)
);
const IoMdClose = dynamic(() =>
  import("react-icons/io").then((mod) => mod.IoMdClose)
);
const FaChevronDown = dynamic(() =>
  import("react-icons/fa").then((mod) => mod.FaChevronDown)
);
import Image from "next/image";
import Link from "next/link";
import { usePathname } from "next/navigation";

const navItems = [
  { name: "Home", href: "/" },
  // { name: "App Features", href: "/appFeatures" },
  { name: "Student Resources", href: "/studentResources" },
  { name: "Start Revising", href: "app.netpractice.app" },
];

const CustomDropdown = ({ i }) => {
  const [isOpen, setIsOpen] = useState(false);
  const dropdownRef = useRef();

  // Close dropdown on outside click
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const DROPDOWNITEMS = [
    { label: "How to prepare for SSC CGL", href: "/studentResources" },
    { label: "Daily Study Tips", href: "/studentResources" },
    { label: "Free Syllabus Completion Plan", isNew: true, href: "/studentResources" },
    { label: "More Student Resources", href: "/studentResources" },
  ];

  return (
    <div key={i} className="relative inline-block text-left" ref={dropdownRef}>
      <button
        className="flex items-center gap-2  py-1 cursor-pointer rounded-lg text-gray-600 font-bold"
        onClick={() => setIsOpen(!isOpen)}
      >
        Resources
        <FaChevronDown className="w-5 h-5" />
      </button>

      {isOpen && (
        <div className="absolute mt-2 w-72 bg-white shadow-lg rounded-lg z-20">
          <ul className="py-2 shadow-2xl">
            {DROPDOWNITEMS.map((item, index) => (
              <Link
            key={index}
            href={item.href}
            // className={`${
            //   !isMobile &&
            //   (pathname === item.href || pathname.startsWith(item.href + "/"))
            //     ? " text-blue-600"
            //     : "text-gray-700"
            // } block hover:text-blue-700 py-2 font-semibold  `}
          >
              <li
                key={index}
                className="pl-3 pr-1 py-2 text-sm font-medium hover:bg-gray-100 cursor-pointer flex justify-between"
              >
                {item.label}
                {item.isNew && (
                  <span className="ml-0 bg-red-600 text-white text-[9px] px-3 py-1 rounded-2xl">
                    NEW
                  </span>
                )}
              </li>
              </Link>
            ))}
          </ul>
        </div>
      )}
    </div>
  );
};

const NavItemsRender = ({ navItems, pathname, isMobile = false }) => {
  return (
    <>
      {navItems.map((item, index) =>
        item.name == "Start Revising" ? (
          <a
            key={index}
            href="https://app.netpractice.app"
            target="_blank"
            rel="noopener noreferrer"
            aria-label="navItem" title="navItem"
            className="btn"
          >
            <button className="flex cursor-pointer items-center bg-orange-600 text-white font-extrabold py-2 px-8 rounded-full shadow-lg hover:shadow-xl hover:bg-orange-700 transition-all duration-300 relative border-b-4 border-2 border-orange-700 hover:border-orange-900  text-shadow-md">
              <Image
                src="/white_icon.svg"
                alt="Start Icon"
                width={20}
                height={20}
                className="mr-3"
              />
              {item.name}
            </button>
          </a>
        ) : item.name == "Student Resources" ? (
          <CustomDropdown key={index} i={index} />
        ) : (
          <Link
            key={index}
            href={item.href}
            className={`${
              !isMobile &&
              (pathname === item.href || pathname.startsWith(item.href + "/"))
                ? " text-blue-600"
                : "text-gray-700"
            } block hover:text-blue-700 py-2 font-semibold  `}
          >
            {item.name}
            {!isMobile &&
              (pathname === item.href ||
                pathname.startsWith(item.href + "/")) && (
                <span className="relative bottom-3 left-0 w-20 h-[2px] bg-blue-700 rounded"></span>
              )}
          </Link>
        )
      )}
    </>
  );
};

const Navbar = () => {
  const [isOpen, setIsOpen] = useState(false);
  const pathname = usePathname();

  const toggleMenu = () => {
    console.log(!isOpen);
    setIsOpen(!isOpen);
  };

  useEffect(() => {
    setIsOpen(false);
  }, [pathname]);

  // console.log(pathname, pathname.slice(0, 2));

  return (
    <header className="sticky top-0 z-50 shadow-md">
      <nav className="flex items-center justify-between px-6 py-4 bg-white">
        {/* Logo */}
        <div className="flex items-center">
        <Link href="/">
          <Image
            src="/full_icon.svg"
            alt="NetPractice"
            width={160}
            height={80}
            priority
          />
          </Link>
        </div>

        {/* Desktop Menu */}
        <div className="hidden md:flex space-x-8 md:items-center">
          <NavItemsRender
            navItems={navItems}
            pathname={pathname}
            isMobile={false}
          />
        </div>

        {/* Mobile Menu Button */}
        <button onClick={toggleMenu} className="md:hidden focus:outline-none" aria-label="menu">
          {isOpen ? <IoMdClose size={28} /> : <IoMenu size={28} />}
        </button>

        {/* Mobile Menu */}
        {isOpen && (
          <div className="absolute flex flex-col items-start gap-4 top-[66px] left-0 w-full bg-white shadow-md py-4 px-6 md:hidden z-100">
            <NavItemsRender
              navItems={navItems}
              pathname={pathname}
              isMobile={true}
            />
          </div>
        )}
      </nav>
    </header>
  );
};

export default Navbar;
